var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drop-zone-wrapper" },
    [
      _c(
        "vue-dropzone",
        {
          ref: "myVueDropzone",
          attrs: {
            id: "dropzone",
            options: _vm.dropzoneOptions,
            "use-custom-slot": true,
            "duplicate-check": true
          },
          on: {
            "vdropzone-file-added": _vm.vfileAdded,
            "vdropzone-success": _vm.vsuccess,
            "vdropzone-complete": _vm.vcomplete,
            "vdropzone-canceled": _vm.vcanceled,
            "vdropzone-error": _vm.verror,
            "vdropzone-removed-file": _vm.vremoved,
            "vdropzone-sending": _vm.vsending,
            "vdropzone-success-multiple": _vm.vsuccessMuliple,
            "vdropzone-sending-multiple": _vm.vsendingMuliple,
            "vdropzone-queue-complete": _vm.vqueueComplete,
            "vdropzone-total-upload-progress": _vm.vprogress,
            "vdropzone-upload-progress": _vm.vSingleProgress,
            "vdropzone-mounted": _vm.vmounted,
            "vdropzone-drop": _vm.vddrop,
            "vdropzone-drag-start": _vm.vdstart,
            "vdropzone-drag-end": _vm.vdend,
            "vdropzone-drag-enter": _vm.vdenter,
            "vdropzone-drag-over": _vm.vdover,
            "vdropzone-drag-leave": _vm.vdleave,
            "vdropzone-duplicate-file": _vm.vdduplicate,
            "vdropzone-max-files-reached": _vm.vdmaxFilesReached
          }
        },
        [
          _c("div", { staticClass: "drop-zone-placeholder" }, [
            _c(
              "svg",
              {
                staticClass: "drop-zone-placeholder__icon",
                attrs: { width: "90", height: "90" }
              },
              [_c("use", { attrs: { "xlink:href": "#file-upload" } })]
            ),
            _c(
              "svg",
              {
                staticClass:
                  "drop-zone-placeholder__icon-uploaded drop-zone-placeholder__icon-uploaded--hidden",
                attrs: { width: "90", height: "90" }
              },
              [_c("use", { attrs: { "xlink:href": "#file-upload-success" } })]
            ),
            _c("p", { staticClass: "drop-zone-placeholder__title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.placeholderTitle) +
                  "\n            "
              )
            ]),
            _c("div", { staticClass: "drop-zone-placeholder__text" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("general.or")) +
                  "\n                "
              ),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "general.files.selectFile",
                    expression: "'general.files.selectFile'"
                  }
                ],
                staticClass: "drop-zone-placeholder__link"
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }